import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class OurMissionPageService {
	getOurMissionData(language) {
		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/ourMission?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new OurMissionPageService();
